import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

interface ErrorPage {
  message: string;
  image?: string;
}

const errors: Record<string, ErrorPage> = {
  'not-found': {
    message: 'Oops! This page does not exist.',
    image: 'error.svg',
  },
  forbidden: {
    message: 'Oops! You do not have permission to access this page.',
    image: 'error.svg',
  },
};

@Component({
  selector: 'ss-stx-shared-error-page',
  standalone: true,
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorPageComponent {
  public error: ErrorPage;

  constructor() {
    const route = inject(ActivatedRoute);

    this.error = errors[route.snapshot.url[0].path];
  }
}
